import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Banks\PartnerBanksController::__invoke
* @see app/Http/Controllers/Banks/PartnerBanksController.php:14
* @route '//bank.finesthub.de/bank-profile'
*/
const PartnerBanksController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: PartnerBanksController.url(options),
    method: 'get',
})

PartnerBanksController.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/bank-profile',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Banks\PartnerBanksController::__invoke
* @see app/Http/Controllers/Banks/PartnerBanksController.php:14
* @route '//bank.finesthub.de/bank-profile'
*/
PartnerBanksController.url = (options?: RouteQueryOptions) => {
    return PartnerBanksController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\PartnerBanksController::__invoke
* @see app/Http/Controllers/Banks/PartnerBanksController.php:14
* @route '//bank.finesthub.de/bank-profile'
*/
PartnerBanksController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: PartnerBanksController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Banks\PartnerBanksController::__invoke
* @see app/Http/Controllers/Banks/PartnerBanksController.php:14
* @route '//bank.finesthub.de/bank-profile'
*/
PartnerBanksController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: PartnerBanksController.url(options),
    method: 'head',
})

export default PartnerBanksController